import styled from '@emotion/styled';

export const Container = styled.div`
  .MuiAutocomplete-popper {
    color: red !important;
    background-color: blue !important;
  }

  .MuiAutocomplete-groupUl {
    color: red;
    background-color: blue !important;
  }
`
